import { useAppSelector } from '~/redux/hooks'
import { selectCurrentUser } from '~/redux/slices/user'

export default function useHasPurchaseTutoringPackages(): boolean {
  const user = useAppSelector(selectCurrentUser)
  return Boolean(user?.studentInfo?.bookings?.length)
}
